import io from "socket.io-client";
import { SOCKET_URL } from "./config/constants";

const socket = io(SOCKET_URL, {
  path: "/video-call-server/socket.io",
  transports: ["polling"],
});

// Asocia este socket al usuario del token en el servidor. Hay que llamarla
// también tras el login: el socket se conecta al cargar la página, cuando
// todavía no hay token, y no vuelve a emitir "connect" al iniciar sesión.
export const authenticateSocket = () => {
  const token = localStorage.getItem("token");
  if (token && socket.connected) socket.emit("authenticate", token);
};

socket.on("connect", authenticateSocket);

export default socket;
